import { $switchCaseStrict } from 'dolla-switch';
import { PermissionValue } from './permissions';
export const documentToProductName = document => {
  switch (document === null || document === void 0 ? void 0 : document.schema_version_name) {
    case 'INFOGRAM':
      return 'DESIGN';
    case 'CORE':
    case 'PITCH':
      return 'PRESENT';
    case 'AIR_LITE':
    case 'AIR_PITCH':
    case 'AIR_VIDEO_LITE':
    case 'AIR_VIDEO_PITCH':
      return 'PRESENT';
    case 'TIMELINE':
    default:
      throw Error();
  }
};
export const documentToDocumentType = document => {
  switch (document === null || document === void 0 ? void 0 : document.schema_version_name) {
    case 'INFOGRAM':
      return 'PUBLISH';
    case 'CORE':
      return 'CLASSIC';
    case 'PITCH':
      return 'PRESENTATION';
    case 'AIR_LITE':
    case 'AIR_PITCH':
    case 'AIR_VIDEO_LITE':
    case 'AIR_VIDEO_PITCH':
      return 'VIDEO';
    case 'TIMELINE':
    default:
      throw Error();
  }
};
export const schemaVersionNameToDocumentType = schemaVersionName => {
  switch (schemaVersionName) {
    case 'AIR_VIDEO_PITCH':
    case 'AIR_VIDEO_LITE':
    case 'AIR_LITE':
    case 'AIR_PITCH':
      return 'VIDEO';
    case 'PITCH':
      return 'PRESENTATION';
    case 'CORE':
      return 'CLASSIC';
    case 'INFOGRAM':
      return 'PUBLISH';
    default:
      break;
  }
};
export const schemaVersionNameToProductType = schemaVersionName => {
  switch (schemaVersionName) {
    case 'AIR_VIDEO_PITCH':
    case 'AIR_VIDEO_LITE':
    case 'AIR_LITE':
    case 'AIR_PITCH':
      return 'VIDEO';
    case 'PITCH':
      return 'NEXT';
    case 'CORE':
      return 'CLASSIC';
    case 'INFOGRAM':
      return 'DESIGN';
    default:
      break;
  }
};
export const unifiedPrivacyToPrivacyLinkAccess = unifiedPrivacy => {
  if (unifiedPrivacy) {
    return $switchCaseStrict(unifiedPrivacy.unified_privacy, {
      open: () => 'ACCESSIBLE_WITH_LINK',
      closed: () => 'COLLABORATOR_ONLY'
    });
  } else {
    throw Error();
  }
};
export const publishedToPrivacyLevel = unifiedPrivacy => {
  if (unifiedPrivacy) {
    return unifiedPrivacy.is_published ? 'PUBLIC' : 'PRIVATE';
  } else {
    throw Error();
  }
};
export const permissionValueToCollaboratorRole = permissionValue => $switchCaseStrict(permissionValue, {
  [PermissionValue.CAN_COMMENT]: () => 'COMMENTER',
  [PermissionValue.CAN_EDIT]: () => 'EDITOR',
  [PermissionValue.CAN_VIEW]: () => 'VIEWER'
});
export const boolToOnOff = isTrue => isTrue ? 'ON' : 'OFF';